"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
function pushFacebookPixelViewContent(priceOffer, isPageViewEvent) {
    const PAGEVIEW_EVENT_NAME = 'subscription_carOfferDetail_pageview';
    const PRICE_OFFER_CHANGE_EVENT_NAME = 'subscription_carOfferDetail_priceOffer_change';
    const priceOfferData = {
        mileageYearly: priceOffer.mileageYearly,
        monthlyPrice: priceOffer.monthlyPrice.withoutVat,
    };
    (0, GtmDataLayer_1.default)({
        priceOfferData,
        event: isPageViewEvent === true ? PAGEVIEW_EVENT_NAME : PRICE_OFFER_CHANGE_EVENT_NAME,
    });
}
exports.default = pushFacebookPixelViewContent;
